export default function arrayToObject(elements, keyName) {
  const obj = {};
  for (const element of elements) {
    obj[`${element[`${keyName}`]}`] = element;
  }
  return obj;
}
